<header>
    <div class="headerFlex">
        <div class="row" >
            <div class="col-md-2 col-ms-2 col-2">
                <div class="logo-container">
                 <!--    <img src="/assets/img/logo.png" class="logo" /> -->
                </div>
            </div>
            <div class="col-md-10 col-sm-10 col-10 text-end"
                style="display: flex;align-items: flex-end; flex-direction: column;">
            <!--     <div class="menu-icon" (click)="openMenu()">
                    <i class="{{menu_icon}}">
                    </i>
                </div> -->
                <div class="desktop_menu" [class.mobile_menu]="menuValue">
                 
                </div>
            </div>
        </div>
    </div>

</header>